// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"23":"countryMap","72":"earthText"}[chunkId] + "." + {"23":"101c49e1","72":"bf3687b5"}[chunkId] + ".css";
};